import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconInvoiceStyle0 = cosmosIconCss;

const CosmosIconInvoice$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconInvoice extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '44ea05cbd58537fe83dbb6a6821ec0b68f54f844', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '32ea26cba1a1ce487c53711d62808735ddaab609', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'e297af670c04600bc5e8825587fff8f022f2163e', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18 18.5a.5.5 0 0 1-.5.5h-12a.5.5 0 0 1-.5-.5v-15a.5.5 0 0 1 .5-.5h7.91a.49.49 0 0 1 .36.15l4.08 4.07a.47.47 0 0 1 .15.35V18.5Zm-1.5-1V8h-3a.5.5 0 0 1-.5-.5v-3H6.5v13h10ZM8 15a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V15Zm.5-4a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-5Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconInvoiceStyle0; }
}, [1, "cosmos-icon-invoice", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-invoice"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-invoice":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconInvoice$1);
            }
            break;
    } });
}

const CosmosIconInvoice = CosmosIconInvoice$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconInvoice, defineCustomElement };
